import React from "react";
import { ReactComponent as MatrixBtnLogo } from "../lib/icons/matrix-logo-btn.svg";
import { useAppDispatch, useAppSelector } from "../../../../../shared/hooks/useReduxHooks";
import { matrixSlice } from "../../../model/matrix-task.slice";
import { focusedTaskSlice } from "../../../../focus-task/model/focus-task.slice";
import ToolTipComponent from "../../../../../shared/ui/Tooltips/Tooltip";
import { useMatrixData } from "../../../lib/hooks/useMatrixData";
import { submenuSlice } from "../../../../../shared/layouts/submenu/model/submenu-model.slice";


export function MatrixButton() {
    const dispatch = useAppDispatch();
    const matrixIsOpen = useAppSelector(matrixSlice.selectors.getIsOpenMatrix);
    const isFocusTask = useAppSelector(focusedTaskSlice.selectors.getFocusTask);
    const { getTooltipData } = useMatrixData();

    function handleClick() {
       dispatch(matrixSlice.actions.setMatrix({isActive: !matrixIsOpen}))
       dispatch(submenuSlice.actions.setSubmenuCollapse({isCollapsed: !matrixIsOpen}))
    }

    const stylesList = {
        width: 'max-content',
        maxWidth: '297px',
        minWidth: '257px',
        backgroundColor: 'rgba(172, 152, 246, 1)',
        top: '140%',
        right: '-35%'
      }

    const stylesListArrow = {
        top: '-7%',
        right: '30%'
      }

    const btnElement = <button className={`focus-task-btn ${matrixIsOpen && `focused`}`} disabled={getTooltipData.isDisabled || isFocusTask} onClick={() => handleClick()}>
        <MatrixBtnLogo className='focus-task-icon'/>
        <p className='focus-task-label'>{matrixIsOpen ? 'Выйти из матрицы' : 'Матрица'}</p>
    </button>

    const tooltipContent = <div>
       <p style={{fontSize: '12px', marginBottom: '6px'}}>Раздели важное и срочное</p>
        <div style={{fontSize: '12px', fontWeight: 400, display: 'flex', flexDirection: 'column', gap: '12px'}}>
            {getTooltipData.description && <p>{getTooltipData.description}</p>}
            {getTooltipData.subDescription && <p>{getTooltipData.subDescription}</p>}
        </div>
    </div>

    return (
        <ToolTipComponent 
            stylesList={stylesList} 
            stylesListArrow={stylesListArrow} 
            active={getTooltipData.isDisabled && !matrixIsOpen}
            children={btnElement}
            tooltipComponent={tooltipContent}
        />
        
    )
}